require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-costa-coffees-first-online-shop.json") })
        }
      }, "path---blog-costa-coffees-first-online-shop");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-costa-coffees-first-online-shop!./.cache/json/blog-costa-coffees-first-online-shop.json
// module id = 432
// module chunks = 231608221292675